module.exports = __webpack_public_path__ + "img/invite-customer.6c2c0a4b.png";